function init () {
  const elements = document.querySelectorAll('[data-inview]')

  if (!elements.length) {
    return
  }

  const options = {
    threshold: 0.3
  }

  elements.forEach(element => observer(options).observe(element))
}

function callback (entries, observer) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-visible')
    }
  })
}

function observer (options) {
  return new IntersectionObserver(callback, options)
}

export default init
